import { Box, Button, Card, CircularProgress, Grid, Modal, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { insertProductApi, updateProductApi } from "src/api/productApi";
import FormikInput from "src/components/FormikInput ";
import { notification } from "src/utils/messages";
import * as Yup from "yup";

export default function ProductInsertUpdateModal({
  addEditModal = false,
  toggleAddEditModal = () => { },
  modalType = "Add",
  rowData = {},
  getProductMethod = () => { }
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  console.log(rowData, "rowData");

  const [loader, setLoader] = useState(false);

  const handleProductSubmit = async (data) => {
    if (modalType === "Edit") {
      setLoader(true);
      let resp = await updateProductApi({
        ...data,
        i_p_id: rowData.i_p_id
      });
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getProductMethod();
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    } else {
      setLoader(true);
      let resp = await insertProductApi(data);
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();

        toggleAddEditModal();
        getProductMethod();
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    }
  };

  const validationSchema = Yup.object({
    i_p_name: Yup.string().required("Product Name is required"),
    i_p_price: Yup.number().required("Product Price is required"),
    i_hsn_code: Yup.number().required("HSN/SAC Code is required"),
    i_p_type: Yup.number()
      .transform((value) => Number(value))
      .min(0)
      .required("Invoice Type is required")
  });

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {modalType} Product
        </Typography>
        <hr />

        {/* <Card sx={{ my: 2, p: 3 }}> */}
        <Formik
          initialValues={{
            i_p_name: modalType === "Edit" ? rowData?.i_p_name : "",
            i_p_price: modalType === "Edit" ? rowData?.i_p_price : "",
            i_hsn_code: modalType === "Edit" ? rowData?.i_hsn_code : "",
            i_d_description: modalType === "Edit" ? rowData?.i_d_description : "",
            i_p_type: modalType === "Edit" ? rowData?.i_p_type + "" : "0"
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => handleProductSubmit(values)}
        >
          {({ values }) => (
            <Form>
              <Grid container spacing={2} sx={{ mt: "5px" }}>
                <Grid item xs={12}>
                  <FormikInput name="i_p_name" label="Product Name" required />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput
                    name="i_p_price"
                    label={values.i_p_type === "1" ? "Product Price (With GST)" : "Product Price"}
                    numericOnly
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput name="i_hsn_code" label="HSN/SAC Code" numericOnly required />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput name="i_d_description" label="Description" multiline rows={3} />
                </Grid>

                <Grid item xs={12}>
                  <FormikInput
                    disabled={modalType === "Edit"}
                    name="i_p_type"
                    label="Invoice Type"
                    select
                    required
                    options={[
                      { label: "Normal Product", value: "0" },
                      { label: "Membership Product", value: "1" }
                    ]}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    variant="caption"
                    sx={{ color: "red", fontWeight: "bold", mt: 0.5, display: "block" }}
                  >
                    Note: If adding a Membership Product, the price must include GST. Otherwise, the
                    price should be listed excluding GST.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 1 }}>
                    <Button variant="outlined" onClick={toggleAddEditModal}>
                      Close
                    </Button>

                    <Button variant="contained" type="submit" disabled={loader}>
                      Submit
                      {loader && <CircularProgress size={16} color="inherit" sx={{ ml: 1 }} />}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
        {/* </Card> */}
      </Box>
    </Modal>
  );
}
